import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
// import {forEach} from '@angular/router/src/utils/collection';

@Injectable({
  providedIn: 'root'
})
export class ImmovableSearchService {

  // Uris
  uriCounties = 'http://localhost:8080/eterra/api/adm/config/getFilterSource/COUNTY_WORKSPACE/1555663841842/null';
  uriUats = 'http://localhost:8080/eterra/api/adm/nomen/ADMINISTRATIVEUNIT/filterByParent/';
  uriLocalities = 'http://localhost:8080/eterra/api/adm/nomen/LOCALITY/filterByParent/';
  uriAdminUnitHierarchy = 'http://localhost:8080/eterra/api/admin_units/findHierarchyByOrgunit';

  constructor(private http: HttpClient) {
  }

  getCounties() {
    return this.http.get(this.uriCounties);
  }

  getUats(countyId: number) {
    return this.http.get(this.uriUats + countyId);
  }

  getLocalities(uatId: number) {
    return this.http.get(this.uriLocalities + uatId);
  }

  checkIfIsIE(data){
    return this.http.post('api/immovable/checkIfIsIE', data);
  }

  searchImmovable(ob,advancedSearch,exactSearch) {
    let setts = {
      url: 'http://localhost:8080/eterra/api/immovable/list',
      // method: 'POST',
      data: {
        filters: [],
        nrElements: 100,
        page: 0,
        sorters: []
      }
    };

    let existImmType = false;
    let obProps = Object.keys(ob);

    for(let key of obProps) {
      if (ob[key] != null && ob[key] !== '') {
        let filter;

        if (["exactSearch"].indexOf(key) > -1){

        } else if (["inscrisCF"].indexOf(key) > -1) {
          filter = {value: ob[key], type: "NUMBER", key: key, op: "="};
        } else if (["exists"].indexOf(key) > -1){
          filter = {value: ob[key], type: "STRING", key: key, op: null};
        } else if (["immovableType"].indexOf(key) > -1){
          filter = {value: ob[key], type: "STRING", key: key, op: "=C"};
          existImmType = true;
        } else if (['locality', 'street'].indexOf(key) > -1){
          if (typeof ob[key] == "number") {
            filter = {value: ob[key], type: "NUMBER", key: key + ".nomenPk", op: "=", builder:"addresses"};
          } else {
            filter = {value: ob[key], type: "STRING", key: key + ".name", op: ":", builder:"addresses"};
          }
        } else if (['isCondominium'].indexOf(key) > -1){
          filter = {value: ob[key], type: "NUMBER", key: key, op: "="};
        } else if (['adminUnit','workspace'].indexOf(key) > -1){
          if (typeof ob[key] == "number") {
            filter = {value: ob[key], type: "NUMBER", key: key + ".nomenPk", op: "="};
          } else {
            filter = {value: ob[key], type: "STRING", key: key + ".name", op: ":"};
          }
        } else {
          if(exactSearch == 1){
            //cautam exact
            if(["buildingNo", "buildingEntryNo", "buildingFloorNo", "buildingUnitNo", "postalNo"].indexOf(key) > -1){
              filter = {value: ob[key], type: "STRING", key: key, op: "=", builder:"addresses"};
            } else if(["titleNo", "landPlotNo", "parcelNo"].indexOf(key) > -1) {
              filter = {value: ob[key], type: "STRING", key: key, op: "=", builder:"parcel"};
            } else if (["paperCadNo" , "topNo" , "paperLbNo" , "identifierDetails"].indexOf(key) > -1) {
              filter = {value: ob[key], type: "STRING", key: key, op: "="};
            }

          } else {
            //cautam cu like la dreapta
            if(["buildingNo", "buildingEntryNo", "buildingFloorNo", "buildingUnitNo", "postalNo"].indexOf(key) > -1){
              filter = {value: ob[key], type: "STRING", key: key, op: ":>", builder:"addresses"};
            } else if(["titleNo", "landPlotNo", "parcelNo"].indexOf(key) > -1) {
              filter = {value: ob[key], type: "STRING", key: key, op: ":>", builder:"parcel"};
            } else if (["paperCadNo" , "topNo" , "paperLbNo" , "identifierDetails"].indexOf(key) > -1) {
              filter = {value: ob[key], type: "STRING", key: key, op: ":>"};
            }
          }
        }

        setts.data.filters.push(filter);
      }
    }

    if(existImmType == false){
      let noParceleFilter = {value: "P", type: "STRING", key: "immovableType" , op: "<>C"};
      setts.data.filters.push(noParceleFilter);
    }

    return this.http.post(setts.url,setts.data);
  }

  getUatHierarchy() {
    return this.http.get(this.uriAdminUnitHierarchy);
  }
}
